import React, { useState } from 'react';
import { Spin } from 'antd';
import { Icon } from 'components';
import { InfoIconGray, secondsToMinutesOrHours, useTranslation } from 'utils';
import './ReportsRateSection.scss';

interface IProps {
  dayTimeSpend: number | undefined;
  nightTimeSpend: number | undefined;
  totalTimeSpend: number | undefined;
  nrOfCallsDay: number | undefined;
  nrOfCallsNight: number | undefined;
}

const ReportsRateSection: React.FC<IProps> = ({
  dayTimeSpend,
  nightTimeSpend,
  totalTimeSpend,
  nrOfCallsDay,
  nrOfCallsNight,
}) => {
  const [info, setInfo] = useState(false);
  const translate = useTranslation();

  const renderTime = (time: number) => {
    if (!time && isNaN(time)) {
      return <Spin size="small" />;
    }
    if (!isNaN(time!)) {
      return secondsToMinutesOrHours(time!);
    }

    return 'No time';
  };

  const braceIt = (str?: string) => {
    return `(${str})`;
  };

  return (
    <>
      <div className="rate-section">
        <div className="rate-section__time">
          <div className="icon-block">
            <Icon name="sun" />
            <span className="icon-block__title txt-bold">
              {translate('DAYLIGHTTariff')} {braceIt(nrOfCallsDay?.toString())}
            </span>
          </div>
          <div className="rate-section__time-hours">{renderTime(dayTimeSpend!)}</div>
        </div>
        {info && (
          <div className="rate-section__subtitle">{translate('DAYLIGHTTariffTimespan')}</div>
        )}
      </div>
      <div className="rate-section rate-section--night">
        <div className="rate-section__time">
          <div className="icon-block">
            <Icon name="moon" />
            <span className="icon-block__title txt-bold">
              {translate('NIGHTTariff')} {braceIt(nrOfCallsNight?.toString())}
            </span>
          </div>
          <div className="rate-section__time-hours">{renderTime(nightTimeSpend!)}</div>
        </div>
        {info && <div className="rate-section__subtitle">{translate('NIGHTTariffTimespan')}</div>}
      </div>
      <div className="rate-section rate-section--total">
        <div className="rate-section__title">
          <span className="rate-section__title-key txt-bold">
            {translate('total')}
            {braceIt(
              nrOfCallsDay && nrOfCallsNight
                ? (nrOfCallsDay + nrOfCallsNight).toString()
                : translate('empty'),
            )}
          </span>
          {totalTimeSpend ? secondsToMinutesOrHours(totalTimeSpend) : <Spin size="small" />}
        </div>
        <div
          className="info"
          role="button"
          tabIndex={0}
          onClick={() => {
            return setInfo((date) => {
              return !date;
            });
          }}
        >
          <InfoIconGray />
        </div>
      </div>
    </>
  );
};

export default ReportsRateSection;
